import { render, staticRenderFns } from "./ContactSelectOption.vue?vue&type=template&id=eb20f37a&scoped=true"
import script from "./ContactSelectOption.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContactSelectOption.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb20f37a",
  null
  
)

export default component.exports